import React from 'react';
import { Grid, Box, MenuItem, TextField } from '@mui/material';
import TransformationBase from './common/TransformationBase';
import { TransformationHeading } from './common/fields/Heading';
import { COMMON_STYLES, COMMON_VALIDATION, COMMON_VALIDATION_PARAM } from './common/Constants';
import { SourceColumnField } from './common/fields/SourceColumnField';
import { OutputColumnField } from './common/fields/OutputColumnField';
import { CheckBoxField } from './common/fields/CheckBoxField';
import TransformationArrayField from './common/fields/TransformationArrayField';

const INITIALSTATE = {
  type: 'trunc_dates',
  alias: '',
  df: '',
  transformations: [
    {
      sourceColumns: [''],
      outputColumn: '',
      param: 'month',
      transformInPlace: false,
    },
  ],
};

const dateTruncOptions = [
  { value: 'year', label: 'Year' },
  { value: 'month', label: 'Month' },
];

const validationSchema = {
  ...COMMON_VALIDATION,
  ...COMMON_VALIDATION_PARAM('This field is required'),
};
const renderTransformationFields = ({ formField, errors, setFieldValue, disableForm, headers }) => {
  const handleInPlaceChange = (index, value) => {
    const newTransforms = [...formField.transformations];
    newTransforms[index].transformInPlace = value;
    if (value) {
      newTransforms[index].outputColumn = '';
    }
    setFieldValue('transformations', newTransforms);
  };

  const renderField = ({ transform, index, headers, disableForm, errors }) => {
    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CheckBoxField
              checked={transform.transformInPlace}
              onChange={(value) => handleInPlaceChange(index, value)}
              disabled={disableForm}
            />
          </Grid>

          <Grid item {...COMMON_STYLES.gridItem}>
            <SourceColumnField
              helperText={
                errors?.sourceColumns || 
                (transform.transformInPlace
                  ? 'This date column will be truncated directly'
                  : 'Select date column to truncate')
              }
              value={transform.sourceColumns?.[0] || ''}
              onChange={(e) => {
                const newTransforms = [...formField.transformations];
                newTransforms[index].sourceColumns = [e.target.value];
                setFieldValue('transformations', newTransforms);
              }}
              headers={headers}
              disabled={disableForm}
              error={!!errors.sourceColumns}
            />
          </Grid>
          <Grid item {...COMMON_STYLES.gridItem}>
            <TextField
              select
              fullWidth
              label="Truncation Level *"
              size="small"
              value={transform.param}
              onChange={(e) => {
                const newTransforms = [...formField.transformations];
                newTransforms[index].param = e.target.value;
                setFieldValue('transformations', newTransforms);
              }}
              disabled={disableForm}
              error={!!errors.param}
              helperText={errors?.param || 'Select the precision level for truncation'}
            >
              {dateTruncOptions.map((format) => (
                <MenuItem key={format.value} value={format.value}>
                  {format.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          {!transform.transformInPlace && (
            <Grid item {...COMMON_STYLES.gridItem}>
              <OutputColumnField
                value={transform.outputColumn}
                onChange={(e) => {
                  const newTransforms = [...formField.transformations];
                  newTransforms[index].outputColumn = e.target.value;
                  setFieldValue('transformations', newTransforms);
                }}
                disabled={disableForm}
                error={!!errors?.outputColumn}
                helperText={errors?.outputColumn || 'Enter output column name'}
              />
            </Grid>
          )}
        </Grid>
      </>
    );
  };
  return (
    <Box sx={COMMON_STYLES.container}>
      <TransformationHeading title='Trim Date - Remove time portion from datetime' disabled={disableForm} />
      <TransformationArrayField
        transformations={formField.transformations}
        setTransformations={(newTransforms) => setFieldValue('transformations', newTransforms)}
        renderField={renderField}
        errors={errors.transformations || []}
        headers={headers}
        disableForm={disableForm}
      />
    </Box>
  );
};

const NodeModal_TruncDates = (props) => (
  <TransformationBase
    {...props}
    INITIALSTATE={INITIALSTATE}
    validationSchema={validationSchema}
    renderTransformationFields={renderTransformationFields}
    transformationType={INITIALSTATE.type}
    tranformationName="Trim Date"
  />
);

export default NodeModal_TruncDates;
